import { Divider } from 'antd-mobile'

interface IProps {
  height?: string
  background?: string
  margin?: number
}

function Gap(props: IProps) {
  const { height = '8px', background = '#f5f5f5', margin = 0 } = props

  return (
    <Divider style={{ height, background, margin, }} />
  )
}

export default Gap
